import { IStudentResponse } from "@/types/views/student.types";
import { GridPaginationModel, GridSortModel } from "@mui/x-data-grid-pro";
import { queryKeys } from "./queryKeys";
import { useAppQuery } from "./useAppQuery";

interface Props {
    searchDebounce?: string;
    paginationModel?: GridPaginationModel;
    sortModel?: GridSortModel;
    statuses?: string[];
    facultyIds?: string[];
    courseIds?: string[];
    providerId?: string;
    enrolmentDateFrom?: string;
    enrolmentDateTo?: string;
    completedDateFrom?: string;
    completedDateTo?: string;
    dueDateFrom?: string;
    dueDateTo?: string;
    expiryDateFrom?: string;
    expiryDateTo?: string;
}

export const useGetTrainingStudents = ({ searchDebounce, paginationModel, sortModel, statuses, facultyIds, courseIds, providerId, enrolmentDateFrom, enrolmentDateTo, completedDateFrom, completedDateTo, dueDateFrom, dueDateTo, expiryDateFrom, expiryDateTo }: Props) => {

    const params = {
        searchText: searchDebounce,
        pageNumber: (paginationModel?.page || 0) + 1,
        pageSize: paginationModel?.pageSize || undefined,
        orderBy: `${sortModel?.[0]?.field} ${sortModel?.[0]?.sort}`,
        statuses: statuses?.length ? statuses : undefined,
        facultyIds: facultyIds?.length ? facultyIds : undefined,
        courseIds: courseIds?.length ? courseIds : undefined,
        providerId: providerId || undefined,
        enrolmentDateFrom,
        enrolmentDateTo,
        completedDateFrom,
        completedDateTo,
        dueDateFrom,
        dueDateTo,
        expiryDateFrom,
        expiryDateTo,
    }

    return useAppQuery<IStudentResponse>('/TrainingManager/students', {
        config: {
            params,
            paramsSerializer: { indexes: null },
        },
        placeholderData: undefined,
        queryKey: queryKeys.trainingStudents.list(params)
    });
}